import React from "react";
import {isNaN} from "formik";

export const mesiIt = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
export const mesiBreviIt = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
export const giorniIt = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']
export const giorniBreviIt = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

// cache casalinga per non dover ricaricare ogni volta il colore del testo per un relativo background, se l'ho già fatto in precedenza
let cachedColors = {};

export const TIPO_ELEMENTO_LABEL = 1;
export const TIPO_ELEMENTO_FORMULA = 2;
export const TIPO_ELEMENTO_VALORE = 3;
export const TIPO_ELEMENTO_SOTTOLIVELLO = 4;
export const TIPO_ELEMENTO_LIVELLO = 5;
export const TIPO_ELEMENTO_LISTA = 6;
export const TIPO_ELEMENTO_SEPARATORE = 7;
export const TIPO_ELEMENTO_CHECK = 8;
export const TIPO_ELEMENTO_NOTA = 9;
export const TIPO_ELEMENTO_BTN_AGGIUNGI = 10;

export const PASSWORD_LENGTH = "password_length"
export const PASSWORD_LETTERS_DIGITS = "password_letters_digits";
export const PASSWORD_SPECIAL_CHARS = "password_special_chars";
export const PASSWORD_NO_FORBIDDEN_CHARS = "password_no_forbidden_chars";

export const STANDARD_CARBON = '4';
export const STANDARD_ESRS = '3';

export function getDecodeJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function getUtenteFromToken(token) {
    var usr = getDecodeJwt(token);
    return usr && usr.user;
}

export function getIdUtenteLoggato(token) {
    var usr = getUtenteFromToken(token);
    return usr && usr.id_utente;
}

export function getTimestampFormattato(data, showSecondi = false) {
    if (!data || data === '') {
        return '';
    }
    return data.substring(8, 10) + '/' + data.substring(5, 7) + '/' + data.substring(0, 4) + (data.length > 10 ? data.substring(10, (showSecondi ? 19 : 16)) : '');
}

export function getDataFormattata(data) {
    if (!data || data === '') {
        return '';
    }
    return data.substring(8, 10) + '/' + data.substring(5, 7) + '/' + data.substring(0, 4);
}

export function getDataPerDb(data) {
    if (!data) {
        return null;
    }
    return data.substring(6, 10) + '-' + data.substring(3, 5) + '-' + data.substring(0, 2);
}

export function convertiDateInDataPerDb(data) {
    if (data) {
        data = new Date(data)
    }

    return data ? [
        data.getFullYear(),
        (data.getMonth() + 1).toString().padStart(2, '0'),
        data.getDate().toString().padStart(2, '0')
    ].join('-') : null;
}

export function convertiTimestampInDataPerDb(data) {
    let d = convertiDateInDataPerDb(data)
    if (d) {
        if (data) {
            data = new Date(data)
        }

        d += ' ' + [
            data.getHours().toString().padStart(2, '0'),
            data.getMinutes().toString().padStart(2, '0'),
            data.getSeconds().toString().padStart(2, '0')
        ].join(':')
    }
    return d;
}

export function getLunedi(data) {
    var d = new Date(data.getTime());
    var day = d.getDay()
    var diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

export function getDomenica(d) {
    var lunedi = getLunedi(d);
    var diff = lunedi.getDate() + 6;
    return new Date(d.setDate(diff));
}

export function aggiungiGiorno(data) {
    var d = new Date(data.getTime());
    var diff = d.getDate() + 1;
    return new Date(d.setDate(diff));
}

export function sottraiGiorno(data) {
    return sottraiGiorni(data, 1);
}

export function sottraiGiorni(data, giorni) {
    var d = new Date(data.getTime());
    var diff = d.getDate() - giorni;
    return new Date(d.setDate(diff));
}

export function aggiungiMese(data) {
    var d = new Date(data.getTime());
    return new Date(d.setMonth(d.getMonth() + 1));
}

export function sottraiMese(data) {
    var d = new Date(data.getTime());
    return new Date(d.setMonth(d.getMonth() - 1));
}

export function getDataJsFormattata(d) {
    return [
        d.getDate().toString().padStart(2, '0'),
        (d.getMonth() + 1).toString().padStart(2, '0'),
        d.getFullYear()
    ].join('/')
}

export function getOreMinuti(data) {
    return (data.length > 10 ? data.substring(10, 16) : '');
}

export function getTimeDataJs(d) {
    let date = new Date(d);
    date.setHours(0, 0, 0, 0);
    return date.getTime()
}

export function getAnno(d) {
    let date = new Date(d);
    date.setDate(1)
    return date.getFullYear()
}

export function getMese(d) {
    let date = new Date(d);
    date.setDate(1)
    let mese = date.getMonth();
    return mesiIt[mese] + ' ' + date.getFullYear()
}

export function getMeseAbbreviato(d) {
    let date = new Date(d);
    date.setDate(1)
    let mese = date.getMonth();
    return mesiBreviIt[mese]
}

export function getGiorno(d) {
    let date = new Date(d);
    let giorno = date.getDay();
    return giorniIt[giorno]
}

export function getStrRgba(strColore) {
    if (!strColore || strColore === '') {
        strColore = '{"r":255,"g":255,"b":255,"a":1}';
    }
    let colore = JSON.parse(strColore);

    return "rgba("
        + colore.r + ", "
        + colore.g + ", "
        + colore.b + ", "
        + colore.a + ")";
}

export function getStrRgbaAlpha1(strColore) {
    if (!strColore || strColore === '') {
        strColore = '{"r":255,"g":255,"b":255,"a":1}';
    }
    let colore = JSON.parse(strColore);

    return "rgba("
        + colore.r + ", "
        + colore.g + ", "
        + colore.b + ", 1)";
}

export function getColor(values) {
    let value = values['colore'];
    if (!value || value === '') {
        value = '{"r":255,"g":255,"b":255,"a":1}';
    }
    return JSON.parse(value);
}

/**
 * Restituisce lo stile dell'elemento del calendario interventi come oggetto di stili, in base al tipo in input
 * @param {*} backgroundColorStr 
 * @returns 
 */
export function getCalendarioStyle(backgroundColorStr) {

    // il colore del testo è bianco o nero a seconda del contrasto
    let colorStrRgba = getTextColorForBackgroundStrRgba(backgroundColorStr);
    let backgroundColorStrRgba = getStrRgba(backgroundColorStr);

    return {'backgroundColor': backgroundColorStrRgba, 'color': colorStrRgba};
}

export function getAnni(startYear, anniInFuturo = 0) {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1920;
    while (startYear <= (currentYear + anniInFuturo)) {
        years.push(startYear++);
    }
    return years;
}

export function handleMoneyChange(e){
    if(e.key !== "Backspace"){
        if(e.target.value.includes('.')){
            if(e.target.value.split('.')[1].length >= 2){
                var num = parseFloat(e.target.value);
                e.target.value = num.toFixed(2);
                e.preventDefault();
            }
        }
    }
}

export function formattaInteroConCommas(x) {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '0';
}

export function ordinaCognomeNome(arr) {
    return arr.sort((a, b) => {
        // Confronta i cognomi
        if (a.cognome !== b.cognome) {
            return a.cognome.localeCompare(b.cognome);
        }
        // Se i cognomi sono uguali, confronta i nomi
        return a.nome.localeCompare(b.nome);
    });
}

// luminance del colore in input, ha senso solo per colori con alpha=1
// https://www.w3.org/WAI/GL/wiki/Relative_luminance
function getLuminance(colore) {

    let luminance = {};

    for (let componente in colore) {

        // ignoro alpha, dovrei avere solo colori piatti
        if (componente === 'a') {
            continue;
        } else {

            let componenteDecimal = colore[componente] / 255;

            let luminanceComponente = componenteDecimal <= 0.03928 ? (componenteDecimal / 12.92) : Math.pow((componenteDecimal + 0.055) / 1.055, 2.4);
            luminance[componente] = luminanceComponente;
        }
    }

    return 0.2126 * luminance.r + 0.7152 * luminance.g + 0.0722 * luminance.b;
}

// contrasto tra due colori in input
// https://www.w3.org/WAI/GL/wiki/Contrast_ratio
function getContrastRatio(colore1, colore2) {

    let luminance1 = getLuminance(colore1);
    let luminance2 = getLuminance(colore2);

    let luminanceLighter = Math.max(luminance1, luminance2);
    let luminanceDarker = Math.min(luminance1, luminance2);

    return (luminanceLighter + 0.05) / (luminanceDarker + 0.05);
}

function getTextColorForBackground(backgroundColorStr) {

    // passo alpha 1 visto che ragiono sempre in rgba
    // il "nero" è il colore base dei testi di YEP
    const BLACK = {r: 33, g: 37, b: 41, a: 1};
    const WHITE = {r: 255, g: 255, b: 255, a: 1};

    if (!backgroundColorStr) {
        return BLACK;
    }

    let backgroundColor = JSON.parse(backgroundColorStr);

    // se il colore ha alpha la definizione di luminance e contrasto non ha senso, restituisco nero
    if (backgroundColor.a !== 1) {
        return BLACK;
    }

    // restituisco il colore che ha il contrasto maggiore con il colore in input
    return getContrastRatio(backgroundColor, BLACK) > getContrastRatio(backgroundColor, WHITE)
        ? BLACK
        : WHITE;
}

/**
 * restituisce la stringa rgba corrispondente al colore del testo (bianco o nero) con contrasto maggiore con il colore in input
 * @param {string} backgroundColorStr stringa con il colore in json rgba (come restituito da db)
 * @returns 
 */
export function getTextColorForBackgroundStrRgba(backgroundColorStr) {

    // se ho già calcolato il colore per il background corrente lo restituisco
    let colorFromCache = cachedColors[backgroundColorStr]
    if (colorFromCache) {
        return colorFromCache; 
    }

    let textColor = getTextColorForBackground(backgroundColorStr);

    // per riutilizzare la funzione che restituisce rgba faccio il doppio passaggio e trasformo prima in stringa
    let color = getStrRgba(JSON.stringify(textColor));

    // salvo il valore ottenuto per non doverlo ricalcolare in seguito
    cachedColors[backgroundColorStr] = color;

    return color;
}

function blend(color, background) {
    let alpha = color.a;
    let oneMinusAlpha = 1 - alpha;

    let newColor = {};

    newColor.r = ((color.r * alpha) + (oneMinusAlpha * background.r));
    newColor.g = ((color.g * alpha) + (oneMinusAlpha * background.g));
    newColor.b = ((color.b * alpha) + (oneMinusAlpha * background.b));

    return newColor;
}

export function toOpaque(color) {

    const WHITE = {r: 255, g: 255, b: 255, a: 1};
    return blend(color, WHITE);
}

export function isLoginPage() {
    return ['#/', '#/login'].includes(window.location.hash)
}

function getSeparatoreDecimali() {
    return ',';
}

function getSeparatoreMigliaia() {
    return '.';
}

export function getValoreFormattato(valore, formato) {
    let val = valore;
    if (formato === '0%') {
        // Numero intero con %
        val = val ? val : 0;
        val = Math.round(val * 100) + '%'
    } else if (formato !== 'General') {
        val = formatExcelStyle(val, formato);
    }
    return val;
}

function formatExcelStyle(value, formato) {
    function formatNumber(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, getSeparatoreMigliaia());
    }

    // Handle different types of values
    if  (value && isNaN(value)) {
        return value;
    } else if (formato.includes('#,##0') || formato.includes('_ -* #,##0_-')
        || formato.includes('\\-* #,##0_-')) {
        if (value > 0) {
            // Positive number
            return formatNumber(Math.round(value));
        } else if (value < 0) {
            // Negative number
            return formatNumber(Math.abs(Math.round(value)));
        } else {
            // Zero value
            return formato.includes('_-* "-"??_-') || formato.includes('_-* "-"??\\ _€_-') ? `-` : value;
        }
    } else {
        return value;
    }
}

export function getPercentuale(percentuale) {
    let perc = Math.round(percentuale || 0);

    let bgClass = 'bg-danger';
    if (perc >= 75) {
        bgClass = 'bg-success'
    } else if (perc >= 50) {
        bgClass = 'bg-info'
    } else if (perc >= 25) {
        bgClass = 'bg-warning'
    }

    return (
        <div className="progress">
            <div className={"progress-bar " + bgClass} role="progressbar" style={{
                width: perc + '%'
            }} aria-valuenow={perc}
                 aria-valuemin="0" aria-valuemax="100"/>
            <span className={"ns-progress-bar-val"}>{perc}%</span>
        </div>
    );
}

export function getSeverityRuolo(ruolo, optionsRuoli) {
    let filtrati = optionsRuoli.filter((r) => r.nome == ruolo);
    if (filtrati && filtrati.length > 0) {
        switch (filtrati[0].codice) {
            case 'SUADMIN':
                return 'danger';
            case 'ADMIN':
                return 'success';
            case 'OP':
                return 'info';
            default:
                return 'warning';
        }
    } else {
        return "warning";
    }
}